module.exports = __webpack_public_path__ + "img/openDoorSet.11ec87b2.svg";